import React, { useState, useEffect } from 'react';
import Table from '@awp/components/table';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { Button } from 'react-bootstrap';
import { Permissions, FORM_MODE } from '@awp/constants';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import Authorize from '@awp/components/Authorize';
import { ActionMenuView, ActionMenuEdit } from '@awp/components/Common/AwpActionMenus';
import Select from 'react-select';
import ObservationTypeService from '@components/ObservationTypeAdmin/ObservationTypeService';

const ObservationTypeTable = ({
  isMedium,
  isLarge,
  data,
  loading,
  setMode,
  mode,
  setObservationType,
  search,
  setSearch,
  filteredData,
  setFilteredData,
  defaultPageSize,
  setDefaultPageSize,
  categoryDropdownOptions,
}) => {
  const [selectedCategoryIds, setSelectedCategoryIds] = useState(null);

  const crudService = new ObservationTypeService(mode);

  const actionMenu = (row) => {
    return (
      <>
        <div>
          <Authorize requires={[Permissions.WriteObservationType]}>
            <ActionMenuEdit
              onClick={() => {
                setMode(FORM_MODE.EDIT);
                setObservationType(row.row.original);
              }}
            />
          </Authorize>
          <ActionMenuView
            onClick={() => {
              setMode(FORM_MODE.VIEW);
              setObservationType(row.row.original);
            }}
          />
        </div>
      </>
    );
  };
  const hasSearch = (src) => {
    return src ? src.toLowerCase().includes(search.toLowerCase()) : false;
  };
  useEffect(() => {
    let filtered = [...data];

    if (!isValueEmpty(search)) {
      filtered = filtered.filter(
        (ot) =>
          hasSearch(ot.Name) ||
          hasSearch(ot.DisplayName) ||
          hasSearch(ot.Definition) ||
          (ot.WagDataType && !isValueEmpty(ot.WagDataType.Name) ? hasSearch(ot.WagDataType.Name) : false),
      );
    }

    if (!isValueEmpty(selectedCategoryIds) && selectedCategoryIds.length > 0) {
      filtered = filtered.filter((ot) => selectedCategoryIds.some((x) => x.value === ot.ObservationCategoryId));
    }

    setFilteredData(filtered);
  }, [search, selectedCategoryIds]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'Name',
        style: { wordBreak: 'break-word' },
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Display Name',
        accessor: 'DisplayName',
        show: isMedium,
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Data Type',
        accessor: 'WagDataType',
        show: isMedium,
        sortType: (rowA, rowB, id) => {
          let valA = '';
          let valB = '';
          if (rowA.original[id] && rowA.original[id].Name) {
            valA = rowA.original[id].Name;
          }

          if (rowB.original[id] && rowB.original[id].Name) {
            valB = rowB.original[id].Name;
          }

          return valA.localeCompare(valB);
        },
        Cell: (p) => {
          return <>{p.value ? p.value.Name : ''}</>;
        },
      },
      {
        Header: 'Actions',
        accessor: 'Id',
        disableSortBy: true,
        Cell: actionMenu,
      },
    ],
    [isLarge, isMedium],
  );

  return (
    <>
      <div className="d-flex">{crudService.crud.getHeader()}</div>
      <div className="container mb-3">
        <div className="row">
          <div className="col-md-4 col-sm-12 pl-0">
            <input
              className="form-control  float-left"
              placeholder="Search..."
              id="user_text_search"
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            ></input>
          </div>
          <div className="col-md-4 pl-0 pr-0">
            <Select
              placeholder={'Select category'}
              options={categoryDropdownOptions}
              isMulti={true}
              isClearable={true}
              onChange={(e) => {
                const newValue = e ?? null;
                setSelectedCategoryIds(newValue);
              }}
            />
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        data={filteredData}
        fetchData={() => {}}
        loading={loading}
        search=""
        defaultSortBy="Name"
        defaultPageSize={defaultPageSize}
        setDefaultPageSize={setDefaultPageSize}
      />
      <div className="container mb-3" style={{ paddingTop: '1.25rem' }}>
        <div className="row">
          <div className="col-md-12 col-lg-12 col-sm-12 pr-0 pl-0">
            <Authorize requires={[Permissions.WriteObservationType]}>
              <Button
                className="mr-2 mr-mini-0 float-left"
                variant="primary"
                onClick={() => {
                  setMode(FORM_MODE.CREATE);
                }}
                disabled={loading}
              >
                Create
              </Button>
            </Authorize>
          </div>
        </div>
      </div>
    </>
  );
};

export default ObservationTypeTable;
